import { toI18n } from 'util/i18n';
import {
  EVENT_ACTIONS as BASE_EVENT_ACTIONS,
  TRACK_ACTION_TYPES,
} from 'util/tracking_constants';

export const DEFAULT_PARTNER_KEY = 'cash_register';

export const DEFAULT_START_WEEK = 1;

export const DEFAULT_V3_ROUTE = '/onboarding/sign-up/v3';

export const OLD_NATIVE_CLIENT_ROUTES = {
  OWNER_INFO: '/onboarding/sign-up/owner_account',
  OWNER_INFO2: '/onboarding/sign-up/owner-account',
};

export const ROUTES = {
  ACCOUNT_DETAILS: `${DEFAULT_V3_ROUTE}/create-owner-account`,
  BUSINESS_INFO: `${DEFAULT_V3_ROUTE}/business-info`,
  CHOOSE_TYPE: '/onboarding/sign-up',
  COMPANY_STEP: '/onboarding/sign-up/company',
  EMPLOYEE_STEP: '/onboarding/sign-up/employee',
  EMPLOYEE_CHECK_STEP: '/onboarding/sign-up/employee-check',
  EMPLOYEE_ASK_MANAGER: '/onboarding/sign-up/employee/ask-manager',
  EMPLOYEE_ASK_MANAGER_WITH_FIND:
    '/onboarding/sign-up/employee/ask-manager-with-find',
  EMPLOYEE_ALREADY_INVITED: '/onboarding/sign-up/employee/already-invited',
  EMPLOYEE_FIND_LOCATION: '/onboarding/sign-up/employee/find-location',
  EMPLOYEE_ACCOUNT_STEP: '/onboarding/sign-up/employee-account',
  EMPLOYEE_SUCCESS_STEP: '/onboarding/sign-up/employee-success',
  JOIN_COMPANY_STEP: '/onboarding/sign-up/join-company',
  OWNER_ACCOUNT_STEP: '/onboarding/sign-up/owner-account',
  OWNER_INFO: `${DEFAULT_V3_ROUTE}/owner-info`,
  OWNER_MOTIVATION: `${DEFAULT_V3_ROUTE}/owner-motivation`,
  PAYROLL_FIRST_SIGNUP: `${DEFAULT_V3_ROUTE}/payroll-first`,
  PAYROLL_FIRST_ACCOUNT_DETAILS: `${DEFAULT_V3_ROUTE}/payroll-first-account-details`,
  SUCCESS_STEP: '/onboarding/sign-up/success',
  QSG_SPLASH: '/quick_start_guide/splash',
  SHORTENED_SIGNUP: `${DEFAULT_V3_ROUTE}/shortened-signup`,
  V3_ROOT: DEFAULT_V3_ROUTE,
};

export const FIELDS = {
  FULL_NAME: 'full_name',
  EMAIL: 'email',
  PASSWORD: 'password',
  PHONE: 'phone',
  COMPANY_NAME: 'company_name',
  COMPANY_ZIP: 'company_zip',
  INDUSTRY: 'industry',
  TEAM_SIZE: 'team_size',
  CITY: 'city',
  COMPANY: 'company',
  WOM: 'wom',
  CURRENT_PAYROLL_SOLUTION: 'current_payroll_solution',
  PAYROLL_NEEDS: 'payroll_needs',
  TEAM_MOTIVATION: 'team_motivation',
  BUSINESS_NAME: 'business_name',
  BUSINESS_ZIP: 'business_zip',
  TERMS: 'terms',
};

export const EVENT_ACTIONS = {
  ...BASE_EVENT_ACTIONS,
  APP_BUTTON_CLICKED: 'App Button Clicked',
  CHECKBOX_CLICKED: 'Checkbox Clicked',
  CLICKED_MOBILE_APP_MODAL: 'Get Mobile App Modal Submitted',
  CONTINUE_CLICKED: 'Continue Clicked',
  CURRENT_PAYROLL_SOLUTION_OPTION_SELECTED:
    'Current Payroll Solution Option Selected',
  DROPDOWN_CLICKED: 'Dropdown Clicked',
  ERROR_MESSAGE_SHOWN: 'Error Message Shown',
  EMPLOYEE_OPTION_CLICKED: 'Employee Option Clicked',
  FIND_LOCATION_CLICKED: 'Find Location Clicked',
  HOMEBASE_LOGO_CLICKED: 'Homebase Logo Clicked',
  INDUSTRY_OPTION_CLICKED: 'Industry Option Clicked',
  LOGIN_CLICKED: 'Login link Clicked',
  PAYROLL_NEEDS_OPTION_SELECTED: 'Payroll Needs Option Selected',
  ONE_LAST_STEP_CLICKED: 'One Last Step Clicked',
  OWNER_MOTIVATION_CLICKED: 'Owner Motivation Clicked',
  OWNER_OPTION_CLICKED: 'Owner Option Clicked',
  SIGN_IN_CLICKED: 'Sign In Clicked',
  TEAM_SIZE_OPTION_CLICKED: 'Team Size Option Clicked',
  USE_CASE_CLICKED: 'Use Case Clicked',
  VIEWED_MOBILE_APP_MODAL: 'Get Mobile App Modal Shown',
  WOM_OPTION_SELECTED: 'WOM Option Selected',
};

export const CLICK_ITEMS = {
  LOGO: 'homebase logo',
  SIGN_IN: 'sign in',
  TYPE_OWNER: 'owner',
  TYPE_EMPLOYEE: 'employee',
  TOS: 'terms_of_service',
  PRIVACY_POLICY: 'privacy_policy',
  USER_AGREEMENT: 'user_agreement',
  CONTINUE: 'continue',
  APP_STORE: 'app_store',
  GOOGLE_PLAY: 'google_play',
  OWNER_MOTIVATION: 'owner motivation',
  LOGIN_CLICKED: 'login',
};

export const FIELD_TYPES = {
  TEXT: 'text',
  PASSWORD: 'password',
  EMAIL: 'email',
  PHONE: 'phone',
};

const trackFocusData = (field, accountType) => [
  EVENT_ACTIONS.FIELD_FOCUSED,
  TRACK_ACTION_TYPES.FOCUS,
  {
    field,
    account_type: accountType,
  },
];

const trackClickData = (ctaEvent, field = {}) => [
  ctaEvent,
  TRACK_ACTION_TYPES.CLICK,
  field,
];

const trackPageViewed = () => [
  EVENT_ACTIONS.PAGE_VIEWED,
  TRACK_ACTION_TYPES.VIEW,
];

export const TRACK_UX_PAYLOADS = {
  PAGE_VIEWED: trackPageViewed(),
  FOCUSED_FULL_NAME: trackFocusData(FIELDS.FULL_NAME, 'owner'),
  FOCUSED_EMAIL: trackFocusData(FIELDS.EMAIL, 'owner'),
  FOCUSED_PASSWORD: trackFocusData(FIELDS.PASSWORD, 'owner'),
  FOCUSED_PHONE: trackFocusData(FIELDS.PHONE, 'owner'),
  FOCUSED_COMPANY_NAME: trackFocusData(FIELDS.COMPANY_NAME),
  FOCUSED_COMPANY_ZIP: trackFocusData(FIELDS.COMPANY_ZIP),
  FOCUSED_BUSINESS_NAME: trackFocusData(FIELDS.BUSINESS_NAME),
  FOCUSED_BUSINESS_ZIP: trackFocusData(FIELDS.BUSINESS_ZIP),
  CLICK_LOGIN_HEADER: trackClickData(EVENT_ACTIONS.LINK_CLICKED, {
    link_text: 'Sign in',
    link_url: 'https://app.joinhomebase.com/accounts/sign-in',
  }),
  CLICK_GET_STARTED: trackClickData(EVENT_ACTIONS.BUTTON_CLICKED, {
    button_text: 'Get Started',
  }),
  CLICK_CONTINUE: trackClickData(EVENT_ACTIONS.BUTTON_CLICKED, {
    button_text: 'Continue',
  }),
  CLICK_NOT_SURE_YET: trackClickData(EVENT_ACTIONS.BUTTON_CLICKED, {
    button_text: 'Not Sure Yet',
  }),
  CLICK_OWNER_MOTIVATION: trackClickData(EVENT_ACTIONS.CHECKBOX_CLICKED),
  CLICK_ONE_LAST_STEP: trackClickData(EVENT_ACTIONS.BUTTON_CLICKED, {
    button_text: 'One Last Step',
  }),
  CLICK_BUSINESS_TYPE: trackClickData(EVENT_ACTIONS.DROPDOWN_CLICKED),
  CLICK_TEXT_LINK: trackClickData(EVENT_ACTIONS.CHECKBOX_CLICKED),
  CLICK_BUTTON: (button_text, step_label) =>
    trackClickData(EVENT_ACTIONS.BUTTON_CLICKED, {
      button_text,
      step_label,
    }),
};

const TEAM_SIZE_OPTIONS = ['xs', 'sm', 'med', 'lg', 'xl'];

export const TEAM_SIZE_SELECT_OPTIONS = TEAM_SIZE_OPTIONS.map(value => ({
  value,
  label: toI18n('onboarding.questions_modal.team_size')[value],
}));

// these keys are referenced in config/settings.yml under
// hiring.popular_roles_from_business_type_keys
const BUSINESS_TYPE_KEYS = [
  'food_coffee',
  'food_table',
  'food_counter',
  'food_bar',
  'health',
  'fitness',
  'home',
  'leisure',
  'prof_service',
  'retail',
  'transportation',
  'education',
  'non_profit',
  'accounting',
  'other',
];

export const BUSINESS_TYPE_SELECT_OPTIONS = BUSINESS_TYPE_KEYS.map(key => ({
  label: toI18n('onboarding.questions_modal.business_types')[key],
  value: key,
}));

const PAYROLL_SOFTWARE_KEYS = ['quickbooks', 'gusto', 'adp', 'square', 'other'];

export const PAYROLL_SOFTWARE_SELECT_OPTIONS = PAYROLL_SOFTWARE_KEYS.map(
  key => ({
    label: toI18n('sign_up.business_info.payroll_provider_types')[key],
    value: key,
  })
);

const SHORTENED_PAYROLL_SOFTWARE_KEYS = [
  'gusto',
  'quickbooks',
  'other',
  'accountant',
  'manually',
];

export const SHORTENED_PAYROLL_SOFTWARE_SELECT_OPTIONS =
  SHORTENED_PAYROLL_SOFTWARE_KEYS.map(key => ({
    label: toI18n('sign_up.shortened_signup.payroll_provider_types')[key],
    value: key,
  }));

const LOCATIONS_COUNT_OPTIONS = [
  ['just_one', '1_location'],
  ['two', '2_locations'],
  ['3_to_5', '3-5_locations'],
  ['6_plus', '6+_locations'],
];

export const LOCATIONS_COUNT_SELECT_OPTIONS = LOCATIONS_COUNT_OPTIONS.map(
  ([i18nKey, value]) => ({
    value,
    label: toI18n('onboarding.questions_modal.locations_count')[i18nKey],
  })
);

const CURRENTLY_USING_OPTIONS = [
  'pen',
  'excel',
  'new_business',
  'different_app',
  'other',
];

export const CURRENTLY_USING_SELECT_OPTIONS = CURRENTLY_USING_OPTIONS.map(
  value => ({
    value,
    label: toI18n('onboarding.questions_modal.currently_using')[value],
  })
);

export const REDIRECT_TO_COMPANY_DASHBOARD_RESPONSES = [
  '2_locations',
  '3-5_locations',
  '6+_locations',
];

const PAYROLL_TYPE_KEYS = [
  'payroll_software',
  'manually',
  'accountant',
  'no_solution',
];

const PAYROLL_TYPE_KEYS_SEGMENTATION = [
  'no_solution',
  'payroll_software',
  'accountant',
  'manually',
];

export const PAYROLL_TYPE_SELECT_OPTIONS = PAYROLL_TYPE_KEYS.map(key => ({
  label: toI18n('onboarding.payroll_questions.question_one_options')[key],
  value: key,
}));

export const PAYROLL_TYPE_SELECT_OPTIONS_SEGMENTATION =
  PAYROLL_TYPE_KEYS_SEGMENTATION.map(key => ({
    label: toI18n('onboarding.payroll_questions.question_one_options_v3')[key],
    value: key,
  }));

const SHORTENED_PAYROLL_TYPE_KEYS_SEGMENTATION = [
  'payroll_software',
  'no_solution',
];

export const SHORTENED_PAYROLL_TYPE_SELECT_OPTIONS_SEGMENTATION =
  SHORTENED_PAYROLL_TYPE_KEYS_SEGMENTATION.map(key => ({
    label: toI18n('sign_up.shortened_signup.payroll_type_options')[key],
    value: key,
  }));

export const SLICE_NAME = 'signUp';

export const SIGNUP_STEPS = {
  OWNER_INFO: {
    id: 1,
    name: 'ownerInfo',
    stepLabel: 'welcome',
  },
  OWNER_MOTIVATION: {
    id: 2,
    name: 'ownerMotivation',
    stepLabel: 'use_type',
  },
  BUSINESS_INFO: {
    id: 3,
    name: 'businessInfo',
    stepLabel: 'business_info',
  },
  ACCOUNT_DETAILS: {
    id: 4,
    name: 'accountDetails',
    stepLabel: 'user_info',
  },
};

export const USER_MOTIVATION_KEYS = {
  SCHEDULING: 'scheduling',
  TIME_TRACKING: 'timeTracking',
  PAYROLL: 'payroll',
  HIRING: 'hiring',
};

export const ENDPOINTS = {
  CREATE_BUSINESS: '/sign_up/create_business',
  CREATE_EMPLOYEE_BUSINESS: '/sign_up/create_employee_business',
  CREATE_JOB: '/onboarding/employees/create_job',
  EMPLOYEE_CHECK: '/onboarding/employee_check',
  LOCATION_SEARCH: '/onboarding/employees/search_location.json',
  UPDATE: '/onboarding/update',
  PRE_SIGNUP_EXPERIMENT_ENROLL: '/pre_signup_enroll',
};

export const STEP_LABELS = {
  USER_ACCOUNT_TYPE: 'user_account_type',
  USER_INFO: 'user_info',
  BUSINESS_INFO: 'business_info',
  USE_CASE_SELECTION: 'use_case_selection',
  VBO_QUESTIONS: 'vbo_questions',
  EMPLOYEE_CHECK: 'employee_check',
  EMPLOYEE_ALREADY_INVITED: 'employee_already_invited',
  EMPLOYEE_NOT_FOUND: 'employee_not_found',
  EMPLOYEE_JOIN_LOCATION: 'employee_join_location',
  EMPLOYEE_JOIN_REQUEST: 'employee_join_request',
  EMPLOYEE_JOIN_SUCCESS: 'employee_join_success',
  INVITE_TEAMMATE: 'invite_teammate',
  SUCCESS_LOADING_SCREEN: 'success_loading_screen',
};

export const ACCOUNT_TYPES = {
  OWNER: 'owner',
  EMPLOYEE: 'employee',
};

export const CURRENT_PAYROLL_SOLUTION_OPTIONS = {
  0: 'payroll_software',
  1: 'manually',
  2: 'accountant',
  3: 'no_solution',
};

export const WOM_OPTIONS = [
  'search',
  'recommendation',
  'pos_or_payroll',
  'review',
  'social',
  'news',
  'mail_flyer',
  'radio_podcast',
  'youtube',
  'other',
];

export const BUSINESS_AGE = {
  0: 'not_open_yet',
  1: 'less_than_6_months',
  2: '6-12_months',
  3: '1-3_years',
  4: '3+_years',
};

const LOCATION_COUNT_KEYS = [
  'single_location',
  'expanding_soon',
  'multi_location',
];

export const LOCATION_COUNT_OPTIONS = LOCATION_COUNT_KEYS.map(key => ({
  label: toI18n('sign_up.business_info.location_count_question_answers')[key],
  value: key,
}));

const XS = 'xs';
const SM = 'sm';
const LG = 'lg';
const XL = 'xl';

export const BUSINESS_SIZE_OPTIONS = [
  { value: XS, label: '1-5' },
  { value: SM, label: '6-10' },
  { value: '11-19', label: '11-19' },
  { value: '20-29', label: '20-29' },
  { value: LG, label: '30-49' },
  { value: XL, label: '50+' },
];

export const EXTENDED_BUSINESS_SIZE_OPTIONS = [
  { value: '50-99', label: '50-99' },
  { value: '100-199', label: '100-199' },
  { value: '200+', label: '200+' },
];

export const MARKETING_DISCOUNT_COUPON_AMEX25 = 'AMEX25';

export const MARKETING_DISCOUNT_COUPON_25_OFF = ['AMEX25'];

export const MARKETING_DISCOUNT_COUPON_15_OFF = ['GOOSE15'];

export const HB_GOOGLE_BUSINESS_TYPE_MAPPING = {
  accounting: 'accounting',
  bar: 'food_bar',
  night_club: 'food_bar',
  bakery: 'food_coffee',
  cafe: 'food_coffee',
  meal_delivery: 'food_counter',
  meal_takeaway: 'food_counter',
  library: 'education',
  primary_school: 'education',
  school: 'education',
  beauty_salon: 'fitness',
  gym: 'fitness',
  hair_care: 'fitness',
  dentist: 'health',
  doctor: 'health',
  hospital: 'health',
  pharmacy: 'health',
  physiotherapist: 'health',
  car_repair: 'home',
  car_wash: 'home',
  electrician: 'home',
  laundry: 'home',
  locksmith: 'home',
  moving_company: 'home',
  painter: 'home',
  plumber: 'home',
  roofing_contractor: 'home',
  amusement_park: 'leisure',
  aquarium: 'leisure',
  art_gallery: 'leisure',
  bowling_alley: 'leisure',
  campground: 'leisure',
  casino: 'leisure',
  movie_rental: 'leisure',
  movie_theater: 'leisure',
  museum: 'leisure',
  park: 'leisure',
  rv_park: 'leisure',
  cemetery: 'non_profit',
  church: 'non_profit',
  hindu_temple: 'non_profit',
  mosque: 'non_profit',
  atm: 'other',
  bank: 'other',
  city_hall: 'other',
  courthouse: 'other',
  embassy: 'other',
  fire_station: 'other',
  funeral_home: 'other',
  local_government_office: 'other',
  lodging: 'other',
  police: 'other',
  post_office: 'other',
  insurance_agency: 'prof_service',
  lawyer: 'prof_service',
  real_estate_agency: 'prof_service',
  bicycle_store: 'retail',
  book_store: 'retail',
  car_dealer: 'retail',
  clothing_store: 'retail',
  convenience_store: 'retail',
  department_store: 'retail',
  drugstore: 'retail',
  electronics_store: 'retail',
  florist: 'retail',
  furniture_store: 'retail',
  hardware_store: 'retail',
  home_goods_store: 'retail',
  jewelry_store: 'retail',
  liquor_store: 'retail',
  pet_store: 'retail',
  restaurant: 'food_table',
  airport: 'transportation',
  bus_station: 'transportation',
  car_rental: 'transportation',
  gas_station: 'transportation',
  light_rail_station: 'transportation',
  parking: 'transportation',
};

export const PAYROLL_EOY_2025_COOKIE_NAME = 'payroll_eoy_2025';

export const BUNDLES_COOKIE_NAME = 'productgrowth_bundles';

export const PAYROLL_FIRST_SIGN_UP_COOKIE_NAME = 'payroll_first_sign_up';

export const SHORTENED_SIGNUP_COOKIE_NAME = 'shorten_web_sign_up';
